import React from "react";
import styled from "styled-components";
import { withTheme } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const moment = require("moment");

const Message = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
  width: 125px;
  padding: 10px;
  border-radius: 3px;
  color: rgb(1, 42, 54);
  svg {
    margin-right: 30px;
  }
`;

export default withTheme(({ date, time }) => {
  return (
    <Message>
      {moment(date).format("MMMM Do")} {moment(time).format("h:mm a")}
    </Message>
  );
});
